import { render } from "./Accordion.vue?vue&type=template&id=39875dba&scoped=true&ts=true"
import script from "./Accordion.vue?vue&type=script&lang=ts"
export * from "./Accordion.vue?vue&type=script&lang=ts"

import "./Accordion.vue?vue&type=style&index=0&id=39875dba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39875dba"]])

export default __exports__